import 'nprogress/nprogress.css'
import 'v3-infinite-loading/lib/style.css'
import './assets/css/base.css'
import './assets/css/style.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'
import { useSettingsStore, useAuthStore } from "@/stores";
import { vCan } from "@/directives/can";
import App from './App.vue'
import router from './router'
import { installVueQuery } from './plugins/vue-query'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
installVueQuery(app)
// Lazy: Quill (~250 kB) is only needed inside a few dialogs/forms, so keep it
// (and its stylesheet) out of the entry bundle every page has to download.
app.component(
  'QuillEditor',
  defineAsyncComponent(() =>
    Promise.all([
      import('@vueup/vue-quill'),
      import('@vueup/vue-quill/dist/vue-quill.snow.css'),
    ]).then(([mod]) => mod.QuillEditor),
  ),
)
app.directive('can', vCan)


useSettingsStore().GetGeneralSettings()

if (useAuthStore().isLoggedIn) {
  useAuthStore().GetProfile()
}

app.mount('#app')
